import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  metaData: {},
};

const fnolInstanceMetaDataSlice = createSlice({
  name: "fnolInstanceMetaData",
  initialState,
  reducers: {
    updatefnolInstanceMetaData(state, action) {
      state.metaData = action.payload;
    },
  },
});

// This thunk action should only be dispatched as part of the fetchFnolInstanceThunk action.
// This is because in its current form the fnolMetaDataSlice is unnormalised in that it contains the fnolInstance state slice as
// a property, and updating it would mean updating it both here as well as in the fnolInstance state slice.
export const { updatefnolInstanceMetaData } = fnolInstanceMetaDataSlice.actions;

export default fnolInstanceMetaDataSlice.reducer;
